import LenderDashboard from "components/elements/LenderDashboard";
import PageHeader from "components/layout/PageHeader";
import { useTenant } from "modules/tenant/providers/tenant-provider";
import BorrowerDashboard from "components/elements/BorrowerDashboard";

function Dashboard() {
  const { user } = useTenant();

  return (
    <>
      <PageHeader title="Dashboard" />
      {user.type === "borrower" ? <BorrowerDashboard /> : <LenderDashboard />}
    </>
  );
}

export default Dashboard;
